<template>
  <div class="screen background" :style="{ backgroundImage: `url('${introductionBackground}')` }">
    <div class="screen-container">
      <div class="cta">
        <vv-button @click="go">{{ $t('lessonStep.introReadyButton') }}</vv-button>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import { mapGetters } from 'vuex'
import { VvButton } from '@/components/common'
import { NEXT_LESSON } from '@/store/modules/lesson/types'

export default {
  name: 'LessonStep',
  components: { VvButton },
  computed: {
    ...mapGetters({ lessonStep: 'currentLessonStep' }),
    introductionBackground() {
      return get(this.lessonStep, 'introductionBackground.file.url')
    }
  },
  methods: {
    go() {
      this.$store.dispatch(NEXT_LESSON)
    }
  }
}
</script>

<style lang="scss" scoped>
.background {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
